import { Breadcrumb, Tag } from "antd";
import React, { useState } from "react";
import Table, { ColumnType } from "antd/es/table";

import { cn } from "../../../lib/utils";
import MyPagination from "../../components/Pagination";
import { IUser } from "../../../types/api/user";
import { useTransactionList } from "../../../hooks/api/transaction/hooks";
import { ITransactionPopulated } from "../../../types/api/transaction";
import { IBucketPayloadType } from "@src/types/api/filling-management";

const TransactionTable = ({
  allowURLStateUpdate = true,
}: {
  allowURLStateUpdate?: boolean;
}) => {
  const [breadcrumb] = useState("Transaction");

  const {
    data,
    refetchWithQuery: refetch,
    isFetching,
  } = useTransactionList({
    page: 1,
    limit: 20,
  });

  const DEFAULT_NUQS_CONFIG = {
    throttleMs: !allowURLStateUpdate ? Infinity : 0,
  };

  const qData = data?.qData ?? { page: 1, limit: 20 };

  const columns: ColumnType<ITransactionPopulated>[] = [
    {
      title: "TRX ID",
      dataIndex: "transaction_Id",
    },
    {
      title: "User ID",
      dataIndex: "user",
      render: (user: IUser) => <span>{user?.user_Id}</span>,
    },

    {
      title: "Payment Id",
      dataIndex: "paymentIntentId",
    },

    {
      title: "Name",
      dataIndex: "user",
      render: (user: IUser) => <span>{user?.name}</span>,
    },
    {
      title: "Filling Year",
      dataIndex: "bucketMetaData",
      render: (bucket: any) => (
        <span className="text-gray-800">{bucket?.filling_year || "-"}</span>
      ),
    },
    {
      title: "Filling Type",
      dataIndex: "bucketMetaData",
       render: (bucket: any) => (
        <span className="text-gray-800">{bucket?.filling_type || "-"}</span>
      ),
    },

    {
      title: "Amount",
      dataIndex: "amount",
     
    },

    {
      title: "Status",
      dataIndex: "status",
      render: (_, row) => {
        const rawStatus = row.status || "FAILED";

        const statusMap: Record<string, string> = {
          SUCCESS: "PAID",
          FAILED: "FAILED",
        };

        const status = statusMap[rawStatus] || "FAILED";

        const colorMap: Record<string, string> = {
          PAID: "bg-green-100 text-green-700",
          FAILED: "bg-red-100 text-red-700",
        };

        return (
          <Tag
            className={cn(
              "px-3 py-1 rounded-full text-xs font-semibold capitalize",
              colorMap[status],
            )}
          >
            {status === "PAID" ? "Paid" : "Failed"}
          </Tag>
        );
      },
    },
  ];

  return (
    <div>
      <h1 className="text-lg sm:text-3xl font-semibold">
        Transaction History{" "}
      </h1>

      <Breadcrumb
        separator=">"
        items={[{ title: "Dashboard" }, { title: breadcrumb }]}
        className="text-xs sm:text-base my-2"
      />

      {/* Table */}
      <Table
        dataSource={data?.data}
        columns={columns}
        rowKey={(item) => item._id ?? ""}
        loading={isFetching}
        pagination={false}
        scroll={{ x: true }}
        size="middle"
        className="custom-rounded-table"
        footer={() => (
          <MyPagination
            qData={qData}
            onChange={refetch}
            total={qData.total}
            DEFAULT_NUQS_CONFIG={DEFAULT_NUQS_CONFIG}
          />
        )}
      />
    </div>
  );
};

export default TransactionTable;
